import { styled } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'react-i18next';

import { ChkGenericLoader, ChkHeader } from '@ui/checkout-components';

import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

export const PageLoadingPlaceholder = () => {
  const { t } = useTranslation();

  return (
    <MainSection>
      <ChkHeader style={visuallyHidden}>
        {t(TRANSLATION_KEYS.PAGE_LOADING)}
      </ChkHeader>
      <ChkGenericLoader />
    </MainSection>
  );
};

const MainSection = styled('main')({
  flex: '1 1 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
